export default "__VITE_ASSET__d2129346__"